import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Meldet, dass in der Masterliste etwas angeklickt wurde, die Detailansicht aber
 * noch die vorige Auswahl zeigt.
 *
 * Hintergrund: Jede Liste entprellt den Klick um eine Sekunde
 * (debounceTime(1000)). In dieser Zeit stand rechts unverändert der alte
 * Datensatz - das konnte suggerieren, man sehe schon die neuen Daten.
 * Der Indikator schliesst diese Lücke, ohne an der Entprellung zu drehen.
 */
@Injectable({ providedIn: 'root' })
export class SelectionPendingService {
  private static readonly SAFETY_TIMEOUT_MS = 5000;

  private readonly pendingSubject = new BehaviorSubject<boolean>(false);
  private safetyTimer: ReturnType<typeof setTimeout> | null = null;

  get pending$(): Observable<boolean> {
    return this.pendingSubject.asObservable();
  }

  start(): void {
    this.clearSafetyTimer();
    this.pendingSubject.next(true);
    // Sicherheitsnetz: Der Indikator darf niemals dauerhaft stehen bleiben,
    // auch wenn eine Auswahl unerwartet nie ankommt.
    this.safetyTimer = setTimeout(
      () => this.pendingSubject.next(false),
      SelectionPendingService.SAFETY_TIMEOUT_MS
    );
  }

  stop(): void {
    this.clearSafetyTimer();
    if (this.pendingSubject.value) {
      this.pendingSubject.next(false);
    }
  }

  private clearSafetyTimer(): void {
    if (this.safetyTimer !== null) {
      clearTimeout(this.safetyTimer);
      this.safetyTimer = null;
    }
  }
}
